import { defineComponent as t, createBlock as o, openBlock as a, unref as r, normalizeClass as d, withCtx as s, renderSlot as i } from "vue";
import n from "../../../components/HttpMethod/HttpMethod.vue.js";
const c = /* @__PURE__ */ t({
  __name: "SidebarHttpBadge",
  props: {
    method: {},
    active: { type: Boolean }
  },
  setup(p) {
    return (e, m) => (a(), o(r(n), {
      class: d([
        "sidebar-heading-type",
        `sidebar-heading-type--${e.method.toLowerCase()}`,
        { "sidebar-heading-type-active": e.active }
      ]),
      method: e.method,
      property: "--method-color",
      short: ""
    }, {
      default: s(() => [
        i(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "method"]));
  }
});
export {
  c as default
};
